import React, { useEffect, useState } from "react";
import { Tabs, Tab, Box, Typography } from "@mui/material";
import VendorInvite from "../VendorInvite/VendorInvite";
import GstAccordionTable from "../DashboardTab/GstFilingTable";
import MerchantInvoiceDelayTable from "../DashboardTab/MerchantInvoiceDelay";
import BuyerVendorsTab from "./VendorsTab";
import VendorOnboardChart from "../InvoiceAutomation/Charts/VendorOnboardDateChart";
import VendorVerificationTable from "./VendorDocumentVerification";

const TabPanel = ({ children, value, index, ...other }) => {
  return (
    <div role="tabpanel" hidden={value !== index} {...other}>
      {value === index && (
        <Box>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
};

const VendorTabLayout = () => {
  const [tabValue, setTabValue] = useState(0);

  const handleChange = (event, newValue) => {
    setTabValue(newValue);
  };

  useEffect(() => {
    const chatActionRow = sessionStorage.getItem("CHAT_ACTION");
    if (!chatActionRow) return;

    const { action } = JSON.parse(chatActionRow);

    if (action === "open_vendor_onboarding_report_analytics") {
      setTabValue(2);
    }

    sessionStorage.removeItem("CHAT_ACTION");
  }, []);

  return (
    <Box sx={{ padding: "5px", margin: "1rem" }}>
      <Tabs
        value={tabValue}
        onChange={handleChange}
        TabIndicatorProps={{
          style: {
            height: "3px",
            backgroundColor: "#2962ff",
            borderRadius: "2px",
          },
        }}
        sx={{
          borderBottom: "1px solid #e0e0e0",

          "& .MuiTab-root": {
            textTransform: "none",
            minWidth: 100,
            fontWeight: 500,
            fontSize: "15px",
            color: "#888",
            transition: "all 0.2s",
          },
          "& .Mui-selected": {
            color: "#2962ff",
            fontWeight: 600,
          },
        }}
      >
        {/* <Tab label="Overview" /> */}
        <Tab label="Initiate Onboarding" />
        <Tab label="Vendor Master" />
        <Tab label="Reports & Analytics" />
      </Tabs>

      {/* <TabPanel value={tabValue} index={0}>
            </TabPanel> */}

      <TabPanel value={tabValue} index={0}>
        <VendorInvite />
      </TabPanel>

      <TabPanel value={tabValue} index={1}>
        <BuyerVendorsTab />
      </TabPanel>

      <TabPanel value={tabValue} index={2}>
        <GstAccordionTable />
        <VendorVerificationTable />
        {/* <MerchantInvoiceDelayTable /> */}
        {/* <VendorOnboardChart/> */}
      </TabPanel>
    </Box>
  );
};

export default VendorTabLayout;
